<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw BookTitlePage-rw exclude-print-rw" epub:type="frontmatter titlepage" id="BookTitlePage2">
<div class="media-rw image-rw float-none-rw floatgalley-none-rw align-center-rw width-auto-rw exclude-auto-rw" id="image2">
<div class="pc-rw" id="pc2"><img alt="" src="Images/all_the_pretty_horses_ebooktitle1800_online.jpg" style="height: 95%;"/></div>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s001-BookTitlePage-01.vue?0843cb7e